export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TopMenuNav.vue?vue&type=template&id=08db4888&"


//////////////////
// WEBPACK FOOTER
// ./src/components/top-menu/TopMenuNav.vue?vue&type=template&id=08db4888&
// module id = null
// module chunks = 